import React from 'react';
import Icon from '../../icon';

class RangePanelHeader extends React.PureComponent {
  render() {
    const {
      prefix,
      startVisibleMonth,
      endVisibleMonth,
      momentLocale,
      locale,
      changeMode,
      goNextMonth,
      goNextYear,
      goPrevMonth,
      goPrevYear,
    } = this.props;

    const localedMonths = momentLocale.months();
    const startMonthLabel = localedMonths[startVisibleMonth.month()];
    const endMonthLabel = localedMonths[endVisibleMonth.month()];
    const startYearLabel = startVisibleMonth.year();
    const endYearLabel = endVisibleMonth.year();
    const btnCls = `${prefix}calendar-btn`;

    return (
      <div className={`${prefix}calendar-panel-header`}>
        <button
          role="button"
          title={locale.prevYear}
          className={`${btnCls} ${btnCls}-prev-year`}
          onClick={goPrevYear}
        >
          <Icon type="chevrons-left" />
        </button>
        <button
          role="button"
          title={locale.prevMonth}
          className={`${btnCls} ${btnCls}-prev-month`}
          onClick={goPrevMonth}
        >
          <Icon type="chevron-left-s" />
        </button>
        <div className={`${prefix}calendar-panel-header-left`}>
          {startYearLabel}
          {' '}
          {startMonthLabel}
        </div>
        <div className={`${prefix}calendar-panel-header-right`}>
          {endYearLabel}
          {' '}
          {endMonthLabel}
        </div>
        <button
          role="button"
          title={locale.nextMonth}
          className={`${btnCls} ${btnCls}-next-month`}
          onClick={goNextMonth}
        >
          <Icon type="chevron-right-s" />
        </button>
        <button
          role="button"
          title={locale.nextYear}
          className={`${btnCls} ${btnCls}-next-year`}
          onClick={goNextYear}
        >
          <Icon type="chevrons-right" />
        </button>
      </div>
    );
  }
}

export default RangePanelHeader;
